/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)
 
import axios from './axios.js'
Vue.prototype.$http = axios

import SetPlaceholderMixin from './mixins/SetPlaceholderMixin'

Vue.mixin(SetPlaceholderMixin)


import vsTable from './components/table/vsTable.vue'  
import vsTh from './components/table/vsTh.vue'
 
Vue.component('vs-table', vsTable)
Vue.component('vs-th', vsTh)

// Filters
import './filters/filters.js' //temporarily commneted by sajjad

 
// mock
 

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

import '@/assets/css/custom.css'

// ACL
import acl from './acl/acl'

import i18n from './i18n'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer)
// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
 
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

import * as _lodash from 'lodash'
window._lodash = _lodash

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import { createProvider } from './vue-apollo'


// Feather font icon
require('./assets/css/iconfont.css')

import { GlobalFunction } from './function'

Vue.prototype.$GlobalFunction = GlobalFunction

Vue.prototype.$showNotification = function (options) {
  const defaultOptions = {
    time: 8000,
    icon: 'close'
  }
  return this.$vs.notify({ ...defaultOptions, ...options })
}
// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

export const notificationBus = new Vue()

import firebase from 'firebase/app'
import '@firebase/messaging'

import DeviceDetector from 'device-detector-js'
if (localStorage.getItem('app-token') && localStorage.getItem('userId')) {


  if (firebase.messaging.isSupported()) {
    const messaging = firebase.messaging()

    if (Notification.permission == 'granted') {
      // Registering Service worker

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('./firebase-messaging-sw.js')
          .then((res) => {
            messaging.useServiceWorker(res)
          })
          .catch((e) => {})
      }

      messaging.usePublicVapidKey(
        'BEHe_9WZxsMyREa4ovovTyP1qRzU5CvQYUwT5cYsceSZ_MXVK1sTUS_wKoabYfJ8ROC_syT-iNWh7ueLjHtxiTQ'
      )

      messaging
        .getToken()
        .then((currentToken) => {
          if (currentToken) {
            const deviceDetector = new DeviceDetector()
            const device = deviceDetector.parse(navigator.userAgent)
            const device_type = `1) Client ${device.client.name} ${device.client.type} 2) OS ${device.os.name} 3) Device ${device.device.type}  ${device.device.brand} ${device.device.model}`

            axios
              .post(
                process.env.VUE_APP_GRAPHQL_HTTP,
                {
                  query: `mutation
                  saveFcmToken 
                    {
                      saveFcmToken (
                      token:"${currentToken}",
                      device:"${device_type}",
                      ) 
                    {
                      status
                    }
                  }
                  `
                },
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      'app-token'
                    )}`,
                    contentType: 'application/json'
                  }
                }
              )
              .then((response) => {})
              .catch((err) => {
                console.log('fcm error', err)
              })
          }  
        })
        .catch((err) => {})

      messaging.onMessage(function (payload) {
        notificationBus.$emit('notification', payload.notification)
        const noteTitle = payload.notification.title
        const noteOptions = {
          body: payload.notification.body,
          icon: payload.notification.icon
        }
        new Notification(noteTitle, noteOptions)
      })
    }
    // }).catch(e => {
    //   console.log(e)
    // });
  }
}

Vue.filter('valid_email', function (value) {
  if (
    (value.slice(0, 8) === 'temp-kv-' &&
      /^\d+$/.test(value.slice(9, 18)) &&
      value.slice(value.length - 14) === 'kidsvision.com') ||
    value.includes('sysgen@kidsvision.com')
  ) {
    return ' '
  } else {
    return value
  }
})

Vue.directive('disable-all', {
  // When all the children of the parent component have been updated
  componentUpdated (el, binding) {
    const tags = ['input', 'button', 'select', 'img']
    if (binding.value) {
      tags.forEach((tagName) => {
        const nodes = el.getElementsByTagName(tagName)
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true
          nodes[i].tabIndex = -1
        }
      })
    } else {
      tags.forEach((tagName) => {
        const nodes = el.getElementsByTagName(tagName)
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = false
          nodes[i].tabIndex = 1
        }
      })
    }
  }
})

new Vue({
  router,
  store,
  acl,
  apolloProvider: createProvider(),
  i18n,
  render: (h) => h(App)
}).$mount('#app')
